/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaGroupPatch = {
    properties: {
        name: {
            type: 'string',
            isRequired: true,
        },
        leagueId: {
            type: 'any-of',
            description: `The league id of the Fantas. If < 0 then the leagues is deleted`,
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
